"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.array.slice.js");

/**
 * 深层数据属性获取
 * @function GetIn - 深层数据属性获取
 * @param {Object|Array} deepObj 深层次数据
 * @param {Array|String} path 路径
 * @param {Any} defaultVal 默认值
 * @returns {Any} 深层次数据属性
 * @example
 * import { GetIn } from '@zz-biz/utils';
 * const deepObj = {
    respCode: 0,
    respData: {
      status: 0,
      data: {
        useInfo: {
          userName: '曹清达',
          sellerAddress: {
            city: '北京市'
          }
        }
      }
    },
    data: [{
      name: '我爱你1'
    }, {
      name: '我爱你2'
    }]
   };
 * GetIn(deepObj,'respData.data.useInfo.sellerAddress.city','默认数据');
 * // return 北京市
 * GetIn(deepObj,'respData.data.useInfoSS.sellerAddress.city','默认数据');
 * // return 默认数据
 * GetIn(deepObj,'data.0.name','我不爱你');
 * // return 我爱你1
 * GetIn(deepObj, 'data.1.name', '我不爱你');
 * // return 我爱你2
 * GetIn(deepObj, ['data', 1, 'name'], '我不爱你');
 * // return 我爱你2
 * GetIn(deepObj, {}, '我不爱你');
 * // console.warn(path 类型只能为字符串或数组)
 * // return 我不爱你
 */
var getIn = function getIn(deepObj, path, defaultValue) {
  try {
    if (!path) {
      return deepObj || defaultValue;
    }

    if (typeof path === 'string' || path instanceof Array) {
      var pathArr = typeof path === 'string' ? path.split('.') : (0, _toConsumableArray2["default"])(path);

      if (!pathArr.length) {
        return deepObj || defaultValue;
      }

      var currPath = pathArr[0];
      var restPath = pathArr.slice(1);
      var currValue = deepObj[currPath];

      if (currValue === undefined) {
        currValue = defaultValue;
        return currValue;
      }

      return restPath.length === 0 ? currValue : getIn(currValue, restPath, defaultValue);
    } else {
      throw 'path 类型只能为字符串或数组';
    }
  } catch (err) {
    return defaultValue;
  }
};

var _default = getIn;
exports["default"] = _default;